import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/lib/i18n";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { BookOpen, Clock } from "lucide-react";

export default function Library() {
  const { user } = useAuth();
  const { t } = useI18n();
  const [rentals, setRentals] = useState([]);

  useEffect(() => {
    if (!user) return;
    api.get("/books/my-library").then(({ data }) => setRentals(data)).catch(() => setRentals([]));
  }, [user]);

  if (!user) return <Navigate to="/" replace />;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="font-serif text-4xl sm:text-5xl text-[#5C061C]">{t("library.title")}</h1>
      <p className="mt-2 text-[#6E6259]">{t("library.subtitle")}</p>

      {rentals.length === 0 ? (
        <div className="mt-10 card-warm rounded-2xl p-10 text-center">
          <BookOpen className="h-12 w-12 text-[#B45309] mx-auto opacity-50" />
          <p className="text-[#6E6259] mt-3">{t("library.empty")}</p>
          <Link to="/books"><Button className="btn-saffron rounded-full mt-4 h-11 px-6">{t("nav.books")}</Button></Link>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
          {rentals.map((r) => (
            <div key={r.id} className="card-warm rounded-2xl overflow-hidden" data-testid={`library-item-${r.id}`}>
              <div className="aspect-[3/4] bg-[#F4EEDF]">
                {r.book?.cover_url && <img src={r.book.cover_url} alt="" className="w-full h-full object-cover" />}
              </div>
              <div className="p-5">
                <h3 className="font-serif text-xl text-[#5C061C]">{r.book_title}</h3>
                <div className="flex items-center gap-2 mt-2 text-sm text-[#6E6259]">
                  <Clock className="h-3.5 w-3.5" />
                  <span>{t("library.expires")}: {new Date(r.expires_at).toLocaleString()}</span>
                </div>
                {r.is_active ? (
                  <Link to={`/reader/${r.book_id}`}>
                    <Button className="btn-saffron rounded-full h-11 mt-4 w-full" data-testid={`library-read-${r.book_id}`}>{t("books.read_now")}</Button>
                  </Link>
                ) : (
                  <Badge className="mt-4 bg-[#DC2626]/10 text-[#DC2626]">{t("library.expired")}</Badge>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
